import { create } from "zustand";

const useFLProjectCreationTab = create((set) => ({
  activeKey: "TAB_PROJECT_INFO",
  setActiveKey: (key) => set({ activeKey: key }),
}));

export default useFLProjectCreationTab;
